/* RESPONSIBLE TEAM: team-proactive-support */
import DefaultPredicateComparisonOptions from 'predicates/models/data/default-predicate-comparison-options';
const defaultDateComparisonOptions = DefaultPredicateComparisonOptions.date;
const customDateComparisonOptions = {
  comparison: defaultDateComparisonOptions.comparison.slice(0, -2)
};
const rulesetDateComparisonOptions = Object.assign({}, defaultDateComparisonOptions, customDateComparisonOptions);
const CustomComparisonOptions = {
  custom: {
    'ruleset.first_went_live_at': {
      date: rulesetDateComparisonOptions
    },
    'ruleset.created_at': {
      date: rulesetDateComparisonOptions
    },
    'ruleset.updated_at': {
      date: rulesetDateComparisonOptions
    }
  }
};
let mergedOptions = Object.assign({}, DefaultPredicateComparisonOptions, CustomComparisonOptions);
export default mergedOptions;